import { getRequest } from './api';

const homeSummaryApi = {
  getHomeSummary: (brandId, { platform } = {}) => {
    const params = { brand_id: brandId };
    if (platform) params.platform = platform;
    return getRequest('/api/home-summary', {}, params);
  },
};

export default homeSummaryApi;

